import { useContext } from 'react';
import { EventHandlerContext } from '../provider/EventHandlerProvider.js';

/**
 * Provides access to the EventHandler client instance.
 *
 * @returns a `EventHandlerContextValues`.
 * @example
 * ```javascript
 * const { client } = useEventHandler();
 * client.subscribe('my-channel');
 * ```
 */
function useEventHandler() {
  const context = useContext(EventHandlerContext);
  if (!context.client && !context.activateClient) {
    throw new Error('Wrap your Component in a EventHandlerProvider Component');
  }
  return context;
}

export { useEventHandler };
//# sourceMappingURL=useEventHandler.js.map
